// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.firstText {
    margin-top: 140px;
}


@media (min-width: 100px) and (max-width: 567px){
    .firstText {
        margin-top: 190px;
    }

    .caroimg {
        height: 100vh;
        
    }
    
    .child2 {
        
        position: relative;
        top: -600px;
        z-index: 1000;
        
        
    }

    .herotext {
        margin-top: 5px;
        font-size: 20px; 
        text-align: justify; 
        margin-left: 20px; 
        margin-right: 20px
    }
    
    
} 


  `, "",{"version":3,"sources":["webpack://./src/components/Privacypolicy.css"],"names":[],"mappings":";;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;;IAEjB;;IAEA;;QAEI,kBAAkB;QAClB,WAAW;QACX,aAAa;;;IAGjB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;;AAGJ","sourcesContent":["\n\n.firstText {\n    margin-top: 140px;\n}\n\n\n@media (min-width: 100px) and (max-width: 567px){\n    .firstText {\n        margin-top: 190px;\n    }\n\n    .caroimg {\n        height: 100vh;\n        \n    }\n    \n    .child2 {\n        \n        position: relative;\n        top: -600px;\n        z-index: 1000;\n        \n        \n    }\n\n    .herotext {\n        margin-top: 5px;\n        font-size: 20px; \n        text-align: justify; \n        margin-left: 20px; \n        margin-right: 20px\n    }\n    \n    \n} \n\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
